module.exports = __webpack_public_path__ + "static/media/52.a71a0183.svg";